<template>
    <div class="trip-list-container">
        <vue3-datatable
            ref="resultTable"
            :rows="tripItems"
            :columns="fields"
            :pagination="false"
            :sticky-header="true"
            :height="'400px'"
            :sortable="true"
            :has-checkbox="hasCheckbox"
            :row-class="getRowClass"
            cell-class="routa-table-cell"
            @row-click="rowClicked"
            @row-select="rowSelected"
        >
            <template #startTime="data">
                {{ data.value.start }}
            </template>
            <template #endTime="data">
                {{ data.value.end }}
            </template>
            <template #tripnote="data">
                <div
                    v-if="data.value.tripnotes?.length > 0"
                    class="trip-notes"
                >
                    <div
                        v-for="note in data.value.tripnotes"
                        :key="note.id"
                        class="trip-note"
                    >
                        <template v-if="note.start_time && note.end_time">
                            <strong>{{ toLocalTime(note.start_time) }}–{{ toLocalTime(note.end_time) }}</strong>:
                        </template>
                        {{ note.note }}
                    </div>
                </div>
            </template>
        </vue3-datatable>
    </div>
</template>

<script>
import { timeUtils } from '../../mixins/TimeUtils'
import { vehicleHelper } from '../../mixins/VehicleMixin'
import Vue3Datatable from '@bhplugin/vue3-datatable'

export default {
    name: 'TripList',
    components: { Vue3Datatable },
    mixins: [timeUtils, vehicleHelper],
    props: {
        isMapViewer: {
            type: Boolean,
            default: false
        },
        trips: {
            type: Array,
            default: () => []
        },
        hasCheckbox: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedRowId: null
        }
    },
    computed: {
        fields() {
            if (!this.isMapViewer) {
                return [
                    {
                        field: 'company',
                        title: this.$t('users.company'),
                        sort: true,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'driver',
                        title: this.$t('trip_list.driver'),
                        sort: true,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'vehicle',
                        title: this.$t('trip_list.vehicle'),
                        sort: true,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'mode',
                        title: this.$t('trip_list.mode'),
                        sort: true,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'customer',
                        title: this.$t('contracts.customer'),
                        sort: true,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'contract',
                        title: this.$t('orders.contract'),
                        sort: true,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'order',
                        title: this.$t('vehicle_position.order'),
                        sort: true,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'startTime',
                        title: this.$t('trip_list.start_time'),
                        sort: true,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'startRoad',
                        title: this.$t('trip_list.start_loc'),
                        sort: true,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'endTime',
                        title: this.$t('trip_list.end_time'),
                        sort: true,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'endRoad',
                        title: this.$t('trip_list.end_loc'),
                        sort: true,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'duration',
                        title: this.$t('trip_list.duration') + ' (H:mm)',
                        sort: true,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'length',
                        title: this.$t('trip_list.trip_length'),
                        sort: true,
                        type: 'number',
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'avg_speed',
                        title: this.$t('trip_list.avg_speed'),
                        sort: true,
                        type: 'number',
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'delivery',
                        title: this.$t('contract_reports.unload_records.delivery_amount'),
                        sort: true,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'tripnote',
                        title: this.$t('daily_summary.trip_notes'),
                        sort: false,
                        minWidth: '20em',
                        headerClass: 'routa-table-header'
                    }
                ]
            }
            return [
                {
                    field: 'vehicle',
                    title: this.$t('trip_list.vehicle'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'mode',
                    title: this.$t('trip_list.mode'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'contract',
                    title: this.$t('orders.contract'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'order',
                    title: this.$t('vehicle_position.order'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'startTime',
                    title: this.$t('trip_list.start_time'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'startRoad',
                    title: this.$t('trip_list.start_loc'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'endTime',
                    title: this.$t('trip_list.end_time'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'endRoad',
                    title: this.$t('trip_list.end_loc'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'duration',
                    title: this.$t('trip_list.duration') + ' (H:mm)',
                    sort: true,
                    type: 'number',
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'length',
                    title: this.$t('trip_list.trip_length'),
                    type: 'number',
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'avg_speed',
                    title: this.$t('trip_list.avg_speed'),
                    sort: true,
                    type: 'number',
                    headerClass: 'routa-table-header'
                }
            ]
        },

        tripItems() {
            return this.trips.map((trip) => {
                const duration_min = this.getDurationInMinutes(trip.start_time, trip.end_time);
                const duration = this.getWorkTime(duration_min);
                return {
                    id: trip.id,
                    company: trip.company_name || '-',
                    driver: trip.driver || '-',
                    vehicle: this.isMapViewer ? this.getVehicleTypeName(trip.vehicle_type) : (trip.vehicle || '-'),
                    mode: this.getTripModeString(trip.mode),
                    customer: trip.customer || '-',
                    contract: trip.contract || '-',
                    order: trip.order || '-',
                    start: this.safeFormatDate(trip.start_time),
                    end: this.safeFormatDate(trip.end_time),
                    startTime: trip.start_time ? new Date(trip.start_time).getTime() : 0,
                    endTime: trip.end_time ? new Date(trip.end_time).getTime() : 0,
                    startRoad: trip.start_road || '-',
                    endRoad: trip.end_road || '-',
                    length: trip.length ? parseFloat(trip.length < 10 ?
                        trip.length.toFixed(3) :
                        trip.length.toFixed(1)
                    ) : 0,
                    duration,
                    avg_speed: this.getAverageSpeed(trip.length, duration_min),
                    delivery: trip.delivery_amount ? trip.delivery_amount + ' ' + trip.delivery_unit : '-',
                    tripnotes: trip.tripnotes || []
                }
            })
        }
    },
    methods: {
        getTableItems() {
            return this.tripItems
        },

        rowClicked(item) {
            this.$emit('rowClicked', item)
            this.selectedRowId = item ? item.id : null
        },

        getRowClass(row) {
            return row.id === this.selectedRowId ? 'routa-table-row selected-row row-id-' + row.id : 'routa-table-row  row-id-' + row.id
        },

        setSelection(index) {
            this.selectedRowId = null
            if (index >= 0 && index < this.trips.length) {
                this.selectedRowId = this.trips[index].id
            }
        },

        resetSelection() {
            this.selectedRowId = null
        },

        rowSelected(selectedRows) {
            this.$emit('row-select', selectedRows)
        },

        scrollToRow(index) {
            this.$nextTick(() => {
                if (index >= 0 && index < this.trips.length) {
                    const targetId = this.trips[index].id
                    const rowElement = document.querySelector(`.row-id-${targetId}`)
                    if (rowElement) {
                        rowElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
                    }
                }
            })
        },

        safeFormatDate(dateString) {
            if (!dateString) return '-'
            try {
                // Simple date formatting without using toLocalTime
                const date = new Date(dateString)
                if (isNaN(date.getTime())) return '-'
                return date.toLocaleString()
            } catch (error) {
                return '-'
            }
        }
    }
}
</script>
<style scoped>
.trip-list-container {
    width: 100%;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.trip-notes {
    max-width: 300px;
}

.trip-note {
    display: block;
    margin-bottom: 4px;
}

.trip-note:last-child {
    margin-bottom: 0;
}
</style>
